<template>
  <section class="w-full flex bg-bg-common-color overflow-hidden" v-loading="detailLoading">
    <div class="p-4 box-border flex-1 flex flex-col overflow-hidden">
      <settle-statistics :so-type="soType" />
      <div :class="`relative flex flex-col flex-1 mt-4 pt-4 bg-white overflow-hidden`">
        <div v-if="soType === soTypeCode.MESSAGE && auditStatus===2 || tableData.length>0 && isRedPocketAudit ? !exportLoading : (!exportLoading && auditStatus===2)" class="flex">
          <div style="width: calc(100% - 70px);" class="mb-4 h-auto">
            <card-tabs v-if="soType === soTypeCode.MESSAGE && auditStatus===2" class="w-full" v-model="activeTab" :tabs="tabs" @change-tab="changeTab">
            </card-tabs>
          </div>
          <div v-if="tableData.length>0" class="p-4 flex justify-end">
            <el-button
              class="text-medium text-theme leading-none cursor-pointer select-none"
              type="primary"
              :loading="exportLoading"
              v-if="exportLoading"
            >
              导出
            </el-button>
            <el-dropdown @command="handleExportDetail" v-if="isRedPocketAudit ? !exportLoading : (!exportLoading && auditStatus===2)">
              <el-button class="text-medium text-theme leading-none cursor-pointer select-none" type="text"> 导出 </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="pdf">导出PDF</el-dropdown-item>
                <el-dropdown-item command="excel">导出Excel</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        
        <!-- <div v-if="soType === soTypeCode.MESSAGE && auditStatus===0" class="p-4"> -->
          <!-- 高级筛选 -->
          <!-- <condition-container 
            :condition="condition" 
            :question-list="questionList" 
            :option="{ isEdit: true }" 
          />
        </div> -->
        <!-- 搜索 -->
        <ul v-if="soType === soTypeCode.MESSAGE && auditStatus===2" class="flex flex-wrap items-center px-4">
          <!-- <li style="width: 160px;" class="mr-3 mb-4">
            <el-input v-model="searchForm.name" size="small" class="w-full-imp" placeholder="请输入姓名" clearable />
          </li> -->
          <li style="width: 190px;" class="mr-3 mb-4">
            <el-input v-model="searchForm.keyword" size="small" class="w-full-imp" placeholder="请输入姓名/手机号码" clearable />
          </li>
          <li style="width: 208px;" class="mb-4">
            <el-button type="primary" size="small" class="ml-0-imp mr-3" @click="getList">查询</el-button>
            <el-button type="primary" size="small" plain class="ml-0-imp no-plainbtn-theme" @click="resetList">重置</el-button>
          </li>
        </ul>
        <div class="flex-1 px-4 overflow-hidden">
          <data-table
            v-if="!tableLoading && tableData.length>0"
            ref="dataTable"
            class="w-full h-full overflow-hidden"
            align="left"
            height="calc(100% - 48px - 30px )"
            :data="tableData"
            :loading="tableLoading"
            :columns="columns"
            :show-page="tableData.length > 0"
            :page="page"
            :show-tooltip="true"
            @size-change="changeSize"
            @pagination-current-change="changeNum"
          >
            <template #no="{ $index}">
              <span>{{ $index + (page.pageSize || 0) * ((page.currentPage || 1) - 1) + 1 }}</span>
            </template>
            <template #approveType="{ row }">
              <span>{{ getApproveType(row.approveType) }}</span>
            </template>
            <template #sendStatus="{ row }">
              <span>{{ getSendStatus(row.sendStatus) }}</span>
            </template>
            <template #sentTime="{ row }">
              <span>{{ row.sendStatus === 1 ? row.sentTime : ''}}</span>
            </template>
            <!-- 短信审核 - 推送状态 -->
            <template #_sendStatus="{ row }">
              <span>{{ getSendStatusMsg(row.sendStatus) }}</span>
            </template>
            <!-- 短信审核 - 是否打开 -->
            <template #opened="{ row }">
              <span>{{ row.opened === 1 ? '是' : '否' }}</span>
            </template>
            <!-- 短信审核 - 答卷状态 -->
            <template #answerStatus="{ row }">
              <span>{{ getAnswerStatus(row.answerStatus) }}</span>
            </template>
            <!-- 短信审核 - 答卷链接 -->
            <template #qsnLink="{ row }">
              <el-button type="text" @click="showAnswer(row)">查看</el-button>
            </template>
            <template #table-footer>
              <!-- 网站协议文案提示 -->
              <DygcFooter class="mt-2 -mb-2" />
            </template>
          </data-table>
          <div v-if="!tableLoading && !detailLoading && !tableData.length" class="w-full h-full flex flex-col justify-center items-center">
            <img src="@/assets/img/tips_yellow.png" width="48" />
            <div class="mt-4 mb-8 leading-22 text-theme-black-850 text-large-x font-semibold">{{ getTaskStatusText }}</div>
            <div v-if="getTaskStatusText !== '待群发短信'" class="leading-22 text-theme-black-650 text-medium">暂无数据</div>

          </div>
        </div>
        
      </div>
    </div>
    <aside class="w-290px h-full bg-white overflow-auto">
      <ApproveDetailSide :id="$route.params.id" :so-type="soType" @finished="getStatistics"/>
    </aside>
  </section>
</template>

<script>
import CardTabs from '@/components/base/CardTabs'
import { downloadDetailPDF, downloadDetailExcel } from '@/api/cost-settlement/settlement-initiate/submitStatement'
import ApproveDetailSide from './components/ApproveDetailSide'
import SettleStatistics from './components/SettleStatistics'
import { messageTabs, soTypeCode, packetDetailColumns, sendedMessageDetailColumns } from '../config/cost-sett'
import { getWjawardSummary, getSendList, exportDetail, getSentMsgList, exportDetailMsg, tabStatistics, getMsgAuditSummary } from '@/api/cost-settlement/approve'
import ConditionContainer from '@/condition/ConditionContainer'
import { checkCondition, createNoopCondition } from '@/condition/utils'
import { pageMixins } from '@/mixins/publish'
import DataTable from '@/components/base/DataTable'
import DygcFooter from 'components/dygc-footer-bottom/index'
import { getSampleAnsForSms } from '@/api/wenjuan/offline'

export default {
  name: 'ApproveDetail',
  components: {
    CardTabs,
    SettleStatistics,
    ConditionContainer,
    DataTable,
    DygcFooter,
    ApproveDetailSide,
    SettleStatistics
  },
  mixins:[pageMixins],
  data() {
    return {
      activeTab: 'all',
      tabs: messageTabs,
      exportLoading: false,
      detailLoading: false,
      soTypeCode,
      condition: {
        matchMethod: 0,
        conditions: []
      },
      questionList: [],
      searchForm:{
        keyword: ''
      },
      tableData:[],
      tableLoading:false,
      packetDetailColumns,
      sendedMessageDetailColumns,
      nosendMessageDetailColumns: [],
      auditStatus: null,
      smsRecordId: null
    }
  },
  computed: {
    isRedPocketAudit() {
      return this.soType && this.soType === this.soTypeCode.PACKET
    },
    isMessageAudit() {
      return this.soType && this.soType === this.soTypeCode.MESSAGE
    },
    soType() {
      const type = this.$route.query.approveType ?? ''
      return type === '' ? '' : +type
    },
    // auditStatus() {
    //   const status = this.$route.query.auditStatus ?? ''
    //   return status === '' ? '' : +status
    // },
    getTaskStatusText() {
      let status = ''
        switch (this.auditStatus) {
          case 1:
            status = '审批中'
            break
          case 2:
            if(this.isMessageAudit) {
              if(this.activeTab === 'all' && !this.searchForm.keyword.length) {
                status = '待群发短信';
              }else {
                status = '';
              }
            }else {
              status = '审批通过';
            }
            break
            case 3:
            status = '审批驳回'
            break
        }
      return status
    },
    columns() {
      let columns = []
      if(this.isMessageAudit && this.auditStatus===2){
        columns = this.sendedMessageDetailColumns
      }
      if(this.isMessageAudit && this.auditStatus!==2){
        columns = this.nosendMessageDetailColumns
      }
      if(this.isRedPocketAudit){
        columns = this.packetDetailColumns
      }
      return columns
    },
    exportApi() {
      if(this.isMessageAudit) {
        return exportDetailMsg
      }else {
        return exportDetail
      }
    }
  },
  created() {
    this.getStatistics()
  },
  methods: {
    getApproveType (type){
      let str = ''
        switch (type) {
          case 0:
            str = '其他'
            break
          case 1:
            str = '自动过审'
            break
          case 2:
            str = '人工审核'
            break
          case 3:
            str = '批量审核'
            break
          case 4:
            str = '质控题'
            break
        }
      return str
    },
    getSendStatus(status){
      let str = ''
        switch (status) {
          case 0:
            str = '失败'
            break
          case 1:
            str = '成功'
            break
          case 2:
            str = '等待'
            break
        }
      return str
    },
    getSendStatusMsg(status){
      let str = ''
        switch (status) {
          case 0:
            str = '发送中'
            break
          case 1:
            str = '发送成功'
            break
          case 2:
          case 3:
            str = '发送失败'
            break
        }
      return str
    },
    getAnswerStatus(status){
      let str = ''
        switch (status) {
          case 0:
            str = '待质控'
            break
          case 1:
            str = '质控通过'
            break
          case 2:
            str = '质控拒绝'
            break
          case 3:
            str = '正在答题'
            break
          case 4:
            str = '被甄别'
            break
          case 5:
            str = '超时'
            break
          case 5:
            str = '超额'
            break
          case null:
            str = '未开始'
            break
        }
      return str
    },
    //tab页签数字
    getTabStatistics() {
      tabStatistics(this.smsRecordId).then(res=> {
        console.log('res123',res)
        if(res.data.code === 0) {
          const tabNums = Object.values(res.data.data)
          this.tabs = messageTabs.map((item, index) => ({
            ...item,
            label: item.label+'('+tabNums[index]+')'
          }))
        }
      }).catch(() => {
        this.$message.error('获取短信统计数量失败')
      })
    },
    getList() {
      if(this.isRedPocketAudit) {
        this.getDataList()
      }else if(this.isMessageAudit){
        if(this.auditStatus===2) {
          this.getSentMsgList()
          this.getTabStatistics()
        }else {
          this.getMsgList()
        }
      }
    },
    getDataList(){
      this.tableLoading = true
      const { currentPage, pageSize } = this.page
      const data={
        surveyId: this.$route.query.surveyId,
        pageNo: currentPage,
        pageSize: pageSize,
        awardId: this.$route.query.awardId,
        params:{
          awardType:5,
          channel:0
        }
      }
      getSendList(data).then(res=>{
        const { code, data } = res.data
        if(code === 0){
          this.tableData = data.records
          this.page.total = data.total
        }
      }).catch(() => {
        this.$message.error('获取发放列表失败')
      }).finally(()=> {
        this.tableLoading = false
      })
    },
    //短信审批
    getMsgList(){
      this.tableLoading = true
      const { currentPage, pageSize } = this.page
      getSampleAnsForSms({
        current: currentPage,
        size: pageSize,
        surveyId: this.$route.query.surveyId,
      }).then(res => {
        if(res.data.code === 0){
          if(res.data.data?.header?.length) {
            this.nosendMessageDetailColumns = res.data.data.header.map(item => ({
              label: item.name,
              value: item.index+''
            }))
          }
          if( res.data.data.tableData && res.data.data.tableData.records.length > 0){
            this.tableData = res.data.data.tableData.records;
            this.page.total = res.data.data.tableData.total
          }
        }
      }).finally(()=> {
        this.tableLoading = false
      })
    },
    //短信审批 已发送
    getSentMsgList() {
      this.tableLoading = true
      const { currentPage, pageSize } = this.page
      let data = {
        pageNo: currentPage,
        pageSize: pageSize,
        recordId: this.smsRecordId,
        keyword: this.searchForm.keyword
      }
      if(this.activeTab === 'sended') {
        data.sendStatus = [1]
      }else if(this.activeTab === 'lose') {
        data.sendStatus = [2,3]
      }
      getSentMsgList(data).then(res=>{
        const { code, data } = res.data
        if(code === 0){
          this.tableData = data.records
          this.page.total = data.total
        }
      }).catch(() => {
        this.$message.error('获取列表失败')
      }).finally(()=> {
        this.tableLoading = false
      })
    },
    resetList(){
      this.searchForm={}
      this.getList()
    },
    handleExportDetail(type) {
      let data = {}
      if(this.isMessageAudit) {
        data = {
          id: this.$route.params.id,
          type,
        }
      }else {
        data ={
          surveyId: this.$route.query.surveyId,
          awardId: this.$route.query.awardId,
          type,
        }
      }
      if (!this.exportLoading) {
        this.exportApi(data).then(res => {
          const url = res?.data?.data ?? ''
          window.open(url)
        })
        .catch(() => {
          this.$message.error('导出pdf明细失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
      }
    },
    changeTab() {
      // this.$refs.settleDetail.doLayout()
      this.searchForm.keyword = ''
      this.getSentMsgList()
    },
    showAnswer(item = {}) {
      const surveyId = this.$route.query.surveyId
      this.$router.push({
        path: `/survey/${surveyId}/data/data-download`,
        query: {
          answerId: item.answerId || ''
        }
      })
    },
    getStatistics() {
      if(this.isRedPocketAudit){
        getWjawardSummary(this.$route.params.id).then(res => {
          this.$nextTick(()=> {
            this.auditStatus = res?.data?.data?.examineStatus
            this.getList()
          })
        }).catch(() => {
          this.$message.error('获取审批状态失败')
        })
        .finally(() => {
        })
      }else if(this.isMessageAudit) {
        getMsgAuditSummary(this.$route.params.id).then(res => {
          this.$nextTick(()=>{
            this.auditStatus = res?.data?.data?.examineStatus
            this.smsRecordId = res?.data?.data?.smsRecordId
            this.getList()
          })
        }).catch(() => {
          this.$message.error('获取审批状态失败')
        })
        .finally(() => {
        })
      } else{
        const status = this.$route.query.auditStatus
        this.auditStatus = status === '' ? '' : +status
        this.getList()
      }
    },
  }
}
</script>
